import {
	Box,
	Button,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	TextField,
	Grid,
	Tab,
	Tabs,
	Typography,
	FormControlLabel,
	FormLabel,
	Radio,
	RadioGroup,
	Checkbox,
} from '@mui/material'
import {
	GridColDef,
	GridRowSelectionModel,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import {
	GridContainer,
	PageContainer,
	PageTop,
	SearchContainer,
	StyledDataGrid,
} from 'components/ApplicationStyles'
import PagePosition from 'components/PagePosition'
import { useEffect, useState } from 'react'
import {
	DatePicker,
	DateTimePicker,
	LocalizationProvider,
} from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { koKR } from '@mui/x-data-grid-premium/locales'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import SendIcon from '@mui/icons-material/Send'

interface TabPanelProps {
	children?: React.ReactNode
	index: number
	value: number
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
			style={{
				width: '100%',
				height: 'calc(100% - 48px)',
				flexGrow: 1,
				display: value === index ? 'flex' : 'none',
			}}
		>
			{value === index && (
				<Box sx={{ px: 0, pt: 1, display: 'flex', width: '100%' }}>{children}</Box>
			)}
		</div>
	)
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	}
}

const Message = () => {
	const apiRef = useGridApiRef()
	const [rowSelectionModel, setRowSelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })

	const [value, setValue] = useState(0)
	const [disabledAdd] = useState(true)
	const [disabledDel] = useState(true)
	const [disabledSave] = useState(true)
	const [disabledSearch, setDisableSearch] = useState(value === 2 ? false : true)
	const [disabledReset, setDisableReset] = useState(value === 2 ? false : true)
	const [disabledExcelDownload] = useState(false)
	const [hideAdd] = useState(true)
	const [hideDel] = useState(true)
	const [hideSave] = useState(true)
	const [hideSearch] = useState(false)
	const [hideReset] = useState(false)
	const [hideExcelDownload] = useState(true)
	const [loading, setLoading] = useState(false)

	const [disableSend, setDisableSend] = useState(true)

	// 추가
	const actionAdd = () => {}

	// 삭제
	const actionDel = () => {}

	// 저장
	const actionSave = () => {}

	// 검색
	const actionSearch = () => {}

	// 초기화
	const actionReset = () => {}

	// 키보드 엔터키 처리
	const onKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
		if (value !== 2) return
		if (e.code === 'Enter' || e.key === 'Enter') {
			e.preventDefault() // 폼 제출 방지
			actionSearch()
		}
	}

	// 폼 제출 방지
	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
	}

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue)
	}

	useEffect(() => {
		setDisableSearch(value === 2 ? false : true)
		setDisableReset(value === 2 ? false : true)
	}, [value])

	return (
		<PageContainer>
			<PageTop>
				<PagePosition
					actionAdd={actionAdd}
					actionDel={actionDel}
					actionSave={actionSave}
					actionSearch={actionSearch}
					actionReset={actionReset}
					actionExcelDownload={() => {}}
					disabledAdd={disabledAdd}
					disabledDel={disabledDel}
					disabledSave={disabledSave}
					disabledSearch={disabledSearch}
					disabledReset={disabledReset}
					disabledExcelDownload={disabledExcelDownload}
					hideAdd={hideAdd}
					hideDel={hideDel}
					hideSave={hideSave}
					hideSearch={hideSearch}
					hideReset={hideReset}
					hideExcelDownload={hideExcelDownload}
					otherButtons={[
						<Button
							key="messageSend"
							variant="contained"
							color="info"
							size="small"
							startIcon={<SendIcon />}
							disabled={disableSend}
						>
							발송하기
						</Button>,
					]}
				/>
				<SearchContainer
					onKeyDown={onKeyDown}
					onSubmit={onSubmit}
				>
					<Grid
						container
						spacing={2}
					>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
								disabled={value === 2 ? false : true}
								sx={{
									'& .MuiOutlinedInput-root.Mui-disabled': {
										backgroundColor: '#efefef',
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
								disabled={value === 2 ? false : true}
								sx={{
									'& .MuiOutlinedInput-root.Mui-disabled': {
										backgroundColor: '#efefef',
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
								disabled={value === 2 ? false : true}
								sx={{
									'& .MuiOutlinedInput-root.Mui-disabled': {
										backgroundColor: '#efefef',
									},
								}}
							/>
						</Grid>
					</Grid>
				</SearchContainer>
			</PageTop>
			<GridContainer>
				<Tabs
					value={value}
					onChange={handleChange}
					indicatorColor="secondary"
					textColor="inherit"
					// variant="fullWidth"
					aria-label="basic tabs example"
				>
					<Tab
						label="SMS"
						{...a11yProps(0)}
					/>
					<Tab
						label="알림톡"
						{...a11yProps(1)}
					/>
					<Tab
						label="발송이력"
						{...a11yProps(2)}
					/>
				</Tabs>
				<CustomTabPanel
					value={value}
					index={0}
				>
					<Grid
						container
						spacing={2}
						sx={{ width: '100%' }}
					>
						<Grid size={{ xs: 12, md: 4 }}>
							<Box
								sx={{
									border: '2px dotted #ccc',
									borderRadius: '5px',
									display: 'block',
									width: '100%',
									padding: '20px',
									mb: 2,
								}}
							>
								<FormControl>
									<FormLabel id="target-group-label">1. 수신 대상</FormLabel>
									<RadioGroup
										aria-labelledby="target-group-label"
										defaultValue="all"
										name="target-buttons-group"
									>
										<FormControlLabel
											value="all"
											control={<Radio />}
											label="전체 시니어 (1,234명)"
										/>
										<FormControlLabel
											value="group"
											control={<Radio />}
											label="특정 그룹 선택"
										/>
										<FormControlLabel
											value="individual"
											control={<Radio />}
											label="개별 선택"
										/>
									</RadioGroup>
								</FormControl>
							</Box>
							<Box
								sx={{
									border: '2px dotted #ccc',
									borderRadius: '5px',
									display: 'block',
									width: '100%',
									padding: '20px',
								}}
							>
								<FormControl>
									<FormLabel id="send-settings-label">3. 발송 설정</FormLabel>
									<RadioGroup
										aria-labelledby="send-settings-label"
										defaultValue="now"
										name="send-settings-group"
									>
										<FormControlLabel
											value="now"
											control={<Radio />}
											label="즉시 발송"
										/>
										<Box sx={{ display: 'flex', alignItems: 'center' }}>
											<FormControlLabel
												value="reserve"
												control={<Radio />}
												label="예약 발송"
											/>
											<LocalizationProvider
												dateAdapter={AdapterMoment}
												adapterLocale="ko"
											>
												<DateTimePicker />
											</LocalizationProvider>
										</Box>
									</RadioGroup>
									<FormControlLabel
										value="resultAction"
										control={<Checkbox />}
										label="발송 결과 이메일 알림"
									/>
								</FormControl>
							</Box>
						</Grid>
						<Grid size={{ xs: 12, md: 4 }}>
							<Box
								sx={{
									border: '2px dotted #ccc',
									borderRadius: '5px',
									display: 'block',
									width: '100%',
									padding: '20px',
								}}
							>
								<Typography
									variant="subtitle1"
									gutterBottom
								>
									2. 알림톡 템플릿
								</Typography>
								<TextField
									id="template-select"
									select
									value="healthCheck"
									fullWidth
								>
									<MenuItem value="healthCheck">건강 체크 알림</MenuItem>
								</TextField>
								<Box
									sx={{
										border: '2px dotted #ccc',
										borderRadius: '5px',
										display: 'block',
										width: '100%',
										padding: '20px',
										backgroundColor: '#f9f9f9',
										my: 2,
									}}
								>
									템플릿 출력 영역
								</Box>
								<FormControlLabel
									value="resultAction"
									control={<Checkbox />}
									label="변수 자동 치환"
								/>
							</Box>
						</Grid>
						<Grid size={{ xs: 12, md: 4 }}>
							<Box
								sx={{
									border: '2px dotted #ccc',
									borderRadius: '5px',
									display: 'block',
									width: '100%',
									padding: '20px',
								}}
							>
								<Typography
									variant="subtitle1"
									gutterBottom
								>
									미리보기
								</Typography>
							</Box>
						</Grid>
					</Grid>
				</CustomTabPanel>
				<CustomTabPanel
					value={value}
					index={1}
				></CustomTabPanel>
				<CustomTabPanel
					value={value}
					index={2}
				>
					<StyledDataGrid
						apiRef={apiRef}
						columns={[]}
						rows={[]}
						showToolbar
						loading={loading}
						localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
					/>
				</CustomTabPanel>
			</GridContainer>
		</PageContainer>
	)
}

export default Message
